import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"
import { requireInventoryUserId } from "../lib/auth.server"
import { UNIT_STATUSES } from "../lib/status"
import {
  bulkUpdateUnitStatus,
  getDashboardCounts,
  getUnit,
  listUnits,
  updateUnitStatus,
} from "../lib/units.server"

const unitStatusSchema = z.enum(UNIT_STATUSES)

const unitFiltersSchema = z
  .object({
    type: z.enum(["sim", "device"]).optional(),
    status: unitStatusSchema.optional(),
    carrierId: z.number().optional(),
    vendorId: z.number().optional(),
    productId: z.number().optional(),
    serialQuery: z.string().optional(),
    page: z.number().int().positive().optional(),
    pageSize: z.number().int().positive().optional(),
  })
  .optional()

export const listUnitsFn = createServerFn({ method: "GET" })
  .validator((data?: unknown) => unitFiltersSchema.parse(data ?? {}))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return listUnits(data ?? {})
  })

export const getUnitFn = createServerFn({ method: "GET" })
  .validator((data: unknown) => z.object({ id: z.number() }).parse(data))
  .handler(async ({ data }) => {
    await requireInventoryUserId()
    return getUnit(data.id)
  })

export const updateUnitStatusFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        unitId: z.number(),
        status: unitStatusSchema,
        note: z.string().nullable().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    const userId = await requireInventoryUserId()
    return updateUnitStatus(data.unitId, data.status, data.note, userId)
  })

export const bulkUpdateUnitStatusFn = createServerFn({ method: "POST" })
  .validator((data: unknown) =>
    z
      .object({
        unitIds: z.array(z.number()).min(1),
        status: unitStatusSchema,
        note: z.string().nullable().optional(),
      })
      .parse(data),
  )
  .handler(async ({ data }) => {
    const userId = await requireInventoryUserId()
    return bulkUpdateUnitStatus(data.unitIds, data.status, data.note, userId)
  })

export const getDashboardCountsFn = createServerFn({ method: "GET" }).handler(
  async () => {
    await requireInventoryUserId()
    return getDashboardCounts()
  },
)
